"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const itemsLength = 4;
export const anchorPushInputs = [
  {
    name: "isGradientEnabled",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "isBackgroundOverlayEnabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isBackgroundImageEnabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isAnchorIconEnabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "content",
    friendlyName: "Anchor push items",
    type: "list",
    required: true,
    defaultValue: [
      {
        text: "See How Smooth It Feels",
        anchorId: "anchorId1",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
      {
        text: "Stay in the Moment",
        anchorId: "anchorId3",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
      {
        text: "Don't Rush the Ritual",
        anchorId: "anchorId2",
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
      },
    ],
    subFields: [
      {
        name: "text",
        type: "string",
        required: true,
      },
      {
        name: "anchorId",
        type: "string",
        required: true,
      },
      {
        name: "img",
        friendlyName: "Anchor push image",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        defaultValue:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F0e1d6bb8acf545c5a63ec12d1b015a41",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("content");
      if (Array.isArray(items) && items.length > itemsLength) {
        options.set("content", items.slice(0, itemsLength));
        alert("You can add maximum 4 items");
      }
    },
  },
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark", "inherit"],
    defaultValue: "inherit",
  },
] as const satisfies Inputs;

export const AnchorPushComponent: RegisteredComponent = {
  name: "AnchorPushComponent",
  component: dynamic(async () =>
    withValidation(
      anchorPushInputs,
      (await import("./AnchorPush")).AnchorPush,
      "AnchorPush"
    )
  ),
  inputs: anchorPushInputs,
};
